import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CompanyMarginsApi } from '../api/company-margins.api';
import {
  CompanyMargin,
  CompanyMarginSave,
} from '../state/company-margins/company-margins-state.model';

@Injectable({ providedIn: 'root' })
export class CompanyMarginsService {
  private readonly _api = inject(CompanyMarginsApi);

  public getCompanyMargins(companyId: number): Observable<CompanyMargin[]> {
    return this._api.getCompanyMargins(companyId);
  }

  public bulkSave(margins: CompanyMarginSave[]): Observable<CompanyMargin[]> {
    return this._api.bulkSave(margins);
  }
}
